<div class="edit-modal-header">
  <ng-content></ng-content>
</div>